export default __webpack_public_path__ + "static/media/dropdown-arrow.dfbaa49d.svg";